























































import { Component, Vue } from 'vue-property-decorator';
// @ts-ignore
import UserAccount from './User-Account.vue';
import StaffMenu from './StaffMenu.vue';
import Menu from './Menu.vue';
import NotificationIcon from './NotificationIcon.vue';

import Auth from '@/services/Auth';

@Component({
	name: 'Header',
	components: {
		UserAccount,
		Menu,
		StaffMenu,
		NotificationIcon,
	},
})
export default class Header extends Vue {
	private Auth: any = Auth;
	private notificationAccess: string = process.env.VUE_APP_NOTIFICATIONS;

	get brokerageId() {
		return this.$store.state.Auth.brokerageId;
	}
}
